module.exports = __webpack_public_path__ + "img/sort-bottom-active.7b3f28b3.svg";